
import { Component, Vue, Watch } from "vue-property-decorator";
import moment, * as Moment from "moment";
import { Route } from "vue-router";
@Component
export default class App extends Vue {
  created() {
    switch (location.pathname.substring(0, 6)) {
      case "/nl-NL":
        this.$i18n.locale = "nl";
        break;
      case "/en-US":
        this.$i18n.locale = "en";
        break;
      case "/de-DE":
        this.$i18n.locale = "de";
        break;
      default:
          this.$i18n.locale = "en";
          break;
    }
    moment.locale(this.$i18n.locale);
  }
}
